function formatNumber (number, decimals = 2) {
  return (Math.round(number * 100) / 100).toFixed(decimals)
}

export {
  formatNumber
}
